import type { CapiPlp } from 'types/capi/plp';

import SortInteractionEvent from '~/events/SortInteractionEvent';
import usePageData from '~/hooks/usePageData';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';
import { getFilters } from '~/routes/plps/plpViewProperties';

export default function useSortInteraction() {
  const { isBot } = useRootData();
  const user = useUser();
  const plp = usePageData<CapiPlp>();

  return (selectedSortKey: string) =>
    new SortInteractionEvent({
      filters: getFilters(plp),
      gesture: 'click',
      guestId: user.guestId,
      isBot,
      selectedSortKey,
      sortKey: plp.applied_sort_key
    }).send();
}
